// client/src/components/pages/HomePage.js
import React from 'react';
// import HeroV3 from '../HeroV3'; // No longer using V3
import HeroV3 from '../HeroV3'; // <-- Import the new V4
import AboutSnippet from '../AboutSnippet';
import FeaturedProducts from '../FeaturedProducts';
import Events from '../Events';
import ProductShowcase from '../ProductShowcase';

const HomePage = () => {
  return (
    <>
      <HeroV3 /> {/* <-- Use the new V4 component */}
      <AboutSnippet />
      <FeaturedProducts />
      <ProductShowcase />
      <Events />
    </>
  );
};

export default HomePage;